<template>
	<div ref="idPan" style="height:100%;">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="flex: 0 0 auto; width:100%; height:50px;">
			<div class="SiftPanel">
				<!-- 平台账号登录, 才可查询指定客户/所有客户, 特定客户只能查询自己的 -->
				<input type="text" style="width:100px; margin-left:10px;" maxlength=30 v-if="this.findCustId==''" v-model="findCustId" :placeholder="getLangText('客户ID')">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('应用')}}</div>
				<input type="text" style="width:100px;" maxlength=30 v-model="findAppName">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('当前版本')}}</div>
				<input type="text" style="width:100px;" maxlength=30 v-model="findCurVerno">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('升级版本')}}</div>
				<input type="text" style="width:100px;" maxlength=30 v-model="findUpdVerno">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('硬件编码')}}</div>
				<input type="text" style="width:200px;" maxlength=30 v-model="findHdcode">
				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onDevListClick"></div>
			</div>
		</div>

		<div ref="idTablePan" style="width:100%; border:0px solid red; display:flex; align-items:center;">
			<ctable :ctrl="ctrlTable"></ctable>
		</div>

		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>
	</div>
</template>

<script>

import ctable     from '../cf/ctable'
import popwin     from '../cf/popwin'
import cselect    from '../cf/cselect'
import cpage      from '../cf/cpage'

export default {
	name: 'upgradeMgr',
	components:{
		ctable, popwin, cselect, cpage
	},
	data () {
		return {
			keyFind: 1000,
			findCustId: "",                         // 客户ID
			findAppName: "",                        // 应用名称
			findCurVerno: "",                       // 当前版本
			findUpdVerno: "",                       // 升级版本
			findHdcode: "",                         // 设备编码
			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 10,                   //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[this.getLangText('共'),this.getLangText('条记录,'),this.getLangText('页'),this.getLangText('条/页'),this.getLangText('页码'),'Go'],
				qryFunc: this.onDevListClick,      //查询回调函数
			},

			ctrlWin:{                               // 弹出窗口控制属性
				w2: 500,
				h2: 440,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				rcallFunc: this.onDevListClick,                 // 指定关闭弹出窗后需要执行的回调方法
			},
			ctrlTable: {                            // 表格控制参数
				headHeight: 50,                     // 表头行的高度
				dataHeight: 46,                     // 数据行的高度
				isCheck: false,                     // 第一列, 是否显示为复选框
				isSplit: false,                     // 固定列、数据列、操作列间是否有渐变分隔
				dataHeads:{                         // 表格表头定义
					head1:[                         // 固定列表头
						{ capt:this.getLangText("硬件编码"), width:300 },
					],
					head2:[                         // 数据列表头
						{ width:120, capt:this.getLangText('应用') },
						{ width:120, capt:this.getLangText('系统') },
						{ width:150, capt:this.getLangText('当前版本') },
						{ width:150, capt:this.getLangText('升级版本') },
						{ width:160, capt:this.getLangText('升级进度') },
						{ width:180, capt:this.getLangText('下载进度') },
						{ width:200, capt:this.getLangText('允许下载时间') },
						{ width:200, capt:this.getLangText('升级完成时间') },
						{ width:100, capt:this.getLangText('客户') },
						{ width:200, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:this.getLangText('操作'), width:180 },
					],
				},
				datas:{ data1:[ ], data2:[ ], data3:[ ] },  // 表格数据定义
			},
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		if( this.login.custId != gPlatCustId )
			 this.findCustId = this.login.custId;  // 非平台客户只能查询自己的
		else this.findCustId = "";

		this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

		this.ctrlTable.self.show();

		this.onDevListClick();
	},
	computed:{

	},
	methods:{
		onResize: function( ){
			this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

			this.childResize( this );
		},
		/* 升级按钮事件响应 */
		onUpgradeClick: function( param ){
			this.ctrlWin.w2 = 800;
			this.ctrlWin.h2 = 500;
			this.ctrlWin.captCont = LangText("选择升级版本");
			this.ctrlWin.vuepath = "/FrameBody/upgradeMgr/verSelect";
			this.ctrlWin.info=param;
			this.ctrlWin.self.onShow();
		},
		/* 查询按钮事件响应 */
		onDevListClick: function(){

			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1, devHdcode: this.findHdcode,
						custId: parseInt(this.findCustId), appName: this.findAppName,
						daCurVerno: this.findCurVerno, daUpdVerno: this.findUpdVerno };

			this.doTrade( "POST", ServAddr+"/api/device/devVerList", this.onDevListOK, true, body, null );
		},
		onDevListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			for(let i=0; i<data.body.devList.length; i++ )
			{
				let item=data.body.devList[i];
				this.ctrlTable.datas.data1.push([ item.devHdcode ]);

				this.ctrlTable.datas.data2.push( [ item.appName, item.daOs ? item.daOs:"", item.daCurVerno, item.daUpdVerno,
							this.getUpdStepText(item.daStep), item.daUpdRate,
							item.daUpdStartTime, this.isNullAs(item.daUpdFinishTime,"").substring(0,19), item.custId, '' ] );

				let op1={capt: this.getLangText("升级"), clk:this.onUpgradeClick, param:item};
				let op2={capt: this.getLangText("重发"), clk:this.onUpdRtyClick,  param:item};

				this.ctrlTable.datas.data3.push([ [ op1, op2 ] ]);
			}

			this.ctrlTable.self.show();
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;
		},
		/* 重发 */
		onUpdRtyClick: function( item ){
			let body={devId: item.daDeviceId, appId: item.appId };
			this.doTrade( "POST", ServAddr+"/api/device/devUpdRty", this.onUpdRtyOK, true, body, null );
		},
		onUpdRtyOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}
			this.onDevListClick();
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// upgradeMgr.vue?45e8ae5c